import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20cinematic%20scene%20with%20spotlight%20beam%20and%20anonymous%20silhouette%20figure%20with%20smartphone%20recording%20urban%20night%20atmosphere%20with%20city%20lights%20in%20background%20mysterious%20mood%20with%20warm%20accents%20editorial%20photography&width=1600&height=600&seq=cta-bg-home&orientation=landscape"
          alt="投稿爆料"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col items-start gap-8 max-w-2xl">
          <h2 className="text-4xl md:text-6xl font-heading font-bold text-background-50 leading-[1.05] lowercase">
            你有料吗？
          </h2>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-950 rounded-full text-sm font-semibold hover:bg-primary-100 transition-all duration-200 cursor-pointer whitespace-nowrap group"
          >
            立即投稿
            <span className="w-5 h-5 flex items-center justify-center bg-foreground-950 text-background-50 rounded-full group-hover:bg-primary-500 transition-colors">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
          <p className="text-background-100/70 text-sm md:text-base leading-relaxed max-w-sm">
            你有独家黑料或内幕消息？<br />欢迎匿名投稿，丰厚奖励等您来拿。
          </p>
        </div>
      </div>
    </section>
  );
}